import { TextField, Button, Box, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import type { FieldType } from './types';

interface OptionsEditorProps {
  fieldType: FieldType;
  options: string[];
  onChange: (options: string[]) => void;
}

export const OptionsEditor = ({
  fieldType,
  options,
  onChange,
}: OptionsEditorProps) => {
  // Legacy templates may still contain HtmlDisplay; it is no longer addable from the UI.
  if ((fieldType as string) === 'HtmlDisplay') {
    const url = options?.[0] || '';
    return (
      <TextField
        fullWidth
        label="URL"
        value={url}
        onChange={(e) => onChange([e.target.value])}
        type="url"
        helperText="URL to display HTML content (mobile only)"
      />
    );
  }

  const handleOptionChange = (index: number, value: string) => {
    const next = [...(options || [])];
    next[index] = value;
    onChange(next);
  };

  const handleAddOption = () => {
    onChange([...(options || []), '']);
  };

  const handleRemoveOption = (index: number) => {
    const next = [...(options || [])];
    next.splice(index, 1);
    onChange(next);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Button
          startIcon={<AddIcon />}
          onClick={handleAddOption}
          size="small"
          variant="outlined"
        >
          Add Option
        </Button>
      </Box>
      {(options || []).map((option, index) => (
        <Box
          key={index}
          sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}
        >
          <TextField
            fullWidth
            label={`Option ${index + 1}`}
            value={option}
            onChange={(e) => handleOptionChange(index, e.target.value)}
            size="small"
          />
          <IconButton
            onClick={() => handleRemoveOption(index)}
            color="error"
            size="small"
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      {(!options || options.length === 0) && (
        <Box sx={{ color: 'text.secondary', fontStyle: 'italic', mt: 1 }}>
          No options added yet
        </Box>
      )}
    </Box>
  );
};
